// [PURPOSE]: Single source of truth for "recover playerStats.id from a
//            persisted snapshot when the in-memory id was dropped."
// [WHY]: loadCharacter and the autosave-restore path both need to ensure
//        playerStats.id is set after rehydrating a saved snapshot. Slot-save
//        (App.jsx ~8094) stamps both `id` and `characterId` onto playerStats,
//        so `characterId` is the durable backstop for `id`.
//        Before May 2026 the autosave-restore path was missing this stamp,
//        which surfaced as a Firebase RTDB rejection on party-create:
//        "value argument contains undefined in property
//        'parties.X.metadata.dmId'" — because metadata.dmId is keyed off
//        playerStats.id. See Rule 9 (autosave save/load match).
// [INTEGRATION]: Imported by src/App.jsx (loadCharacter and autosave-restore)
//        and exercised directly by src/__tests__/migrations/autosaveSnapshot.test.js.

/**
 * Normalize the `id` field on a player-stats object loaded from a saved
 * snapshot. Idempotent and null-safe — pass-through on already-correct input.
 *
 * @param {object} playerStats - mutated in place AND returned
 * @returns {object} the same playerStats reference, with `.id` populated
 *                   from `.characterId` when missing.
 */
export function normalizeRestoredCharacterId(playerStats) {
  if (!playerStats || typeof playerStats !== 'object') return playerStats;
  if (!playerStats.id && playerStats.characterId) {
    playerStats.id = playerStats.characterId;
  }
  return playerStats;
}
